
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class AppLinearProgressBar extends Vue {
  @Prop({
    required: false,
    default: '#ffffff',
    type: String,
  })
  private readonly backgroundColor!: string

  @Prop({
    required: true,
    default: '#000000',
    type: String,
  })
  private readonly color!: string

  @Prop({
    required: true,
    default: 0,
    type: Number,
    validator: (value: number): boolean => value >= 0 && value <= 100,
  })
  private readonly value!: number

  get wrapperStyle () {
    return {
      backgroundColor: this.backgroundColor,
    }
  }

  get fillStyle () {
    return {
      backgroundColor: this.color,
      width: `${this.value}%`,
    }
  }
}
